import React, { useRef } from 'react';
import { MdOutlineCloudUpload } from "react-icons/md";


const DragAndDropInputDiv = ({ getFile }) => {
    const inputFileRef = useRef(null);

    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        getFile(e.dataTransfer.files[0]);
    }
    const handleImgSize = (url, file) => {
        let pic = new Image();
        pic.src = url;
        console.log(file,"handleImgSize")
        setTimeout(() => {
            getFile(file);
        }, 100)
    }
    const convertToBase64 = (selectedFile) => {
        console.log(selectedFile,"convertToBase64")

        const reader = new FileReader()

        reader.readAsDataURL(selectedFile)

        reader.onload = () => {
            handleImgSize(reader.result, selectedFile)
        }
    }
    function handleimageChange(e) {
        convertToBase64(e.target.files[0])
    }
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }
    const handleimageClick = () => {
        inputFileRef.current.click()
    }

    return (
        <>
            <div
                style={{
                    width: `500px`,
                    border: `1px solid #C6C6C6`,
                    padding: `16px 24px`,
                    borderRadius: `8px`,
                    display: `flex`,
                    alignItems: `center`,
                    justifyContent: `center`,
                    flexDirection: `column`,
                    gap: `12px`,
                    backgroundColor: `#F9F9F9`,
                }}
                onDrop={(e) => handleDrop(e)}
                onDragEnter={(e) => handleDrag(e)}
                onDragOver={(e) => handleDrag(e)}
                onDragLeave={e => handleDrag(e)}
            >
                <MdOutlineCloudUpload size={50} style={{ color: `#45b77c`, cursor: `pointer`}} onClick={handleimageClick}/>
                <div style={{display: 'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
                    <p style={{ textAlign: `center`, color: `#45b77c`, fontWeight: `400`, fontSize: `14px`, fontFamily: `Inter`, marginBottom: `4px` }}>
                        <label htmlFor='inputTeamImage' style={{ color: `#45b77c`, fontWeight: `500`, cursor: `pointer`,marginInlineEnd: `4px`}}

                        >
                            <input type="file" id='inputTeamImage' style={{ display: 'none' }} ref={inputFileRef}
                                accept=".png, .jpg, .jpeg, .svg, .gif"
                                onChange={(e) => handleimageChange(e)}
                            />
                            Upload Identity Proof{' '}
                        </label>
                        Drag and Drop
                    </p>
                    <label htmlFor='dragTeamImage' style={{ color: `#45b77c`, fontWeight: `400`, fontSize: `12px`, fontFamily: `Inter`, textAlign: `center` }}
                    >
                        SVG, PNG OR JPG  (max. 800x400px)
                    </label>
                </div>
            </div>
        </>
    )
}

export default DragAndDropInputDiv